export default __webpack_public_path__ + "static/media/belusci.f9c4ec14.gif";